import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const role = {
  namespaced: true,

  state() {
    return {
      allRoles: [],
      totalRoles: 0,
      loading: false,
      loadingActiveRole: false,
      roleCache: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      allActiveRole: [],
      allActiveAction: null,
      requestActiveRole: null,
      totalPage: 0,
      detail: null,
    };
  },

  mutations: {
    setRoles(state, { payload }) {
      state.allRoles = payload.data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearRoles(state) {
      state.allRoles = [];
      state.totalRoles = 0;
    },

    setDetailData(state, payload) {
      state.detail = payload;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalRoles(state, { payload }) {
      state.totalRoles = parseInt(payload.data.length, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setLoadingActiveRole(state, loadingActiveRole) {
      state.loadingActiveRole = loadingActiveRole;
    },

    // eslint-disable-next-line no-shadow
    removeRole(state, { role }) {
      state.totalRoles -= 1;
      state.allRoles = state.allRoles.filter((value) => value.role != role);
    },
    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    pushRole(state, { payload }) {
      state.allRoles.push(payload);
      state.totalRoles += 1;
    },

    editRole(state, { payload, index }) {
      Object.assign(state.allRoles[index], payload);
    },

    setActiveRoles(state, { payload }) {
      state.allActiveRole = payload.data;
    },
    setActiveAction(state, { payload }) {
      state.allActiveAction = payload.list;
    },
  },

  actions: {
    async fetchRoles(ctx, { date, search }) {
      ctx.commit('clearRoles');
      const data = JSON.stringify({
        user_id: '',
        search,
        version: btoa(
          CryptoJS.SHA256(
            `${date}${atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))}`
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/rbac/role/list`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        ctx.commit('setTotalRoles', {
          payload: responseData,
        });
        ctx.commit('setRoles', { payload: responseData });
      }
    },

    async fetchActiveRoles(ctx, { date, source }) {
      ctx.commit('clearRoles');

      const urlControll =
        source == 'merchant'
          ? 'rbac/role/portal-merchant-list'
          : 'rbac/role/list';

      const data = JSON.stringify({
        user_id: '',
        search: {
          role_type: '',
        },
        version: btoa(
          CryptoJS.SHA256(
            `${date}${atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))}`
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/${urlControll}`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        ctx.commit('setActiveRoles', {
          payload: responseData,
        });
      }
    },

    async fetchActiveAction(ctx, { date, source }) {
      const urlControll =
        source == 'merchant'
          ? 'audit_trail/portal-merchant/list-action'
          : 'audit_trail/trail/list-action';

      const data = JSON.stringify({
        version: btoa(
          CryptoJS.SHA256(
            `${date}${atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))}`
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/${urlControll}`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        ctx.commit('setActiveAction', {
          payload: responseData.data,
        });
      }
    },

    // eslint-disable-next-line no-shadow
    async createRole(ctx, { date, role, description, role_type }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        role,
        description,
        role_type,
        version: btoa(
          CryptoJS.SHA256(
            role +
              description +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/rbac/role/add`;

      const responseData = await postApi(ctx, urlApi, data);

      let returnVal = false;

      if (responseData?.code == '200') {
        ctx.commit('pushRole', {
          payload: { role },
        });
        returnVal = true;
      }

      return returnVal;
    },

    // eslint-disable-next-line no-shadow
    async updateRole(ctx, { date, role, description, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: index,
        role,
        description,
        version: btoa(
          CryptoJS.SHA256(
            index.toString() +
              role.toString() +
              description +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/rbac/role/update`;

      const responseData = await postApi(ctx, urlApi, data);

      let returnVal = false;
      if (responseData?.code == '200') {
        const updatedRole = responseData.data;
        ctx.commit('editRole', {
          payload: updatedRole,
          index,
        });
        returnVal = true;
      }

      return returnVal;
    },

    // eslint-disable-next-line no-shadow
    async deleteRole(ctx, { date, role }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        role,
        version: btoa(
          CryptoJS.SHA256(
            role.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/rbac/role/delete`;

      const responseData = await postApi(ctx, urlApi, data);

      let returnVal = false;
      if (responseData?.code == '200') {
        ctx.commit('removeRole', {
          role,
        });
        returnVal = true;
      }

      return returnVal;
    },
  },
};
export default role;
